import { Card, Grid, Typography } from "@material-ui/core";
import { CostCalculationTable } from "common/components/sale";
import { SubformProps } from "common/components/SubformProps";
import { CreateInvestmentManageable } from "common/store/investment/types";
import { SaleManageable } from "common/store/sale/types";
import { Mode } from "common/utils/utility";
import React from "react";
import { useTranslation } from "react-i18next";

interface CostCalculationSubformProps extends SubformProps<CreateInvestmentManageable> {
  sale: SaleManageable;
}

export const CostCalculationSubform = (props: CostCalculationSubformProps) => {
  // Hooks
  const { t } = useTranslation();

  const {
    sale,
    values
  } = props;

  return (
    <Card>
      <Grid container direction="column" spacing={6}>
        <Grid item>
          <Typography variant="body1" color="textSecondary">
            {t("In the following, we fulfill our legal obligation to provide information by providing you with a list of the costs associated with your investment and all costs related to a notional reference value of 10,000 euros in a transparent form")}
          </Typography>
        </Grid>

        <Grid container item>
          <CostCalculationTable
            mode={Mode.View}
            values={sale.percentages}
            amount={values.amountShares}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
